import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// Thunk to handle template download
export const downloadTemplate = createAsyncThunk("templateDownload/downloadTemplate", async (channelId, { rejectWithValue }) => {
	try {
		// Make request with blob response type
		const response = await axiosHttp.get(`channel/${channelId}/unit/template`, {
			responseType: "blob",
		});

		// Create blob URL
		const blob = new Blob([response.data], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		const url = window.URL.createObjectURL(blob);

		// Create temporary link and trigger download
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", "cashback_template.xlsx");
		document.body.appendChild(link);
		link.click();

		// Clean up
		link.parentNode.removeChild(link);
		window.URL.revokeObjectURL(url);

		return { success: true };
	} catch (error) {
		console.error("Download error:", error);
		return rejectWithValue(error.response?.data || "Download failed");
	}
});

const initialState = {
	isLoading: false,
	isSuccess: false,
	error: null,
};

const templateDownloadSlice = createSlice({
	name: "templateDownload",
	initialState,
	reducers: {
		resetTemplateDownload: (state) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(downloadTemplate.pending, (state) => {
				state.isLoading = true;
				state.isSuccess = false;
				state.error = null;
			})
			.addCase(downloadTemplate.fulfilled, (state) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.error = null;
			})
			.addCase(downloadTemplate.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.error = action.payload;
			});
	},
});

export const { resetTemplateDownload } = templateDownloadSlice.actions;

export default templateDownloadSlice.reducer;
